<div class="stepper-container">
  <div class='stepper-header'>{{label}}</div>
  <div class="stepper-wrapper">
    <div class="stepper">
       <button 
        (click)="decrement()"
        class="stepper-btn stepper-btn-subtract" 
        type="button">
        -
      </button>
      <input 
        [ngModel]="currentValue"
        (keyup)="handleKeyPress($event)"
        type="number"
        class="stepper-input">
      <button 
        (click)="increment()"
        class="stepper-btn stepper-btn-add" 
        type="button">
        +
      </button>
    </div>

  </div>
</div>